import userInfoService from "@/services/userInfo";
import store from "@/store";
import { apiWrapper } from "@/services/api";

export const issueExternalCoupon = async (
  masterBookId,
  bookId,
  isValid = true
) => {
  try {
    //stored issued successful external coupons -> for retry purpose
    store.commit("ticketing/setIssuedExternalMasterCouponIds", []);
    const issuedExternalMasterCouponIds = [];
    const acquireType = isValid ? "valid_book" : "get_book";

    const gettableResponse = await apiWrapper(
      "GET",
      `gettable_coupons?master_book_id=${masterBookId}&acquire_type=${acquireType}`
    );

    const user_id = userInfoService.getUserIdFromIdToken();

    let issuedCount = 0;
    const gettableMasterCouponIds = [];

    gettableResponse.data.forEach((coupon) => {
      if (coupon.gettable_counts != null && coupon.gettable_counts > 0) {
        gettableMasterCouponIds.push(coupon.master_coupon_id);
      }
    });

    if (gettableMasterCouponIds.length > 0) {
      for (var i = 0; i < gettableMasterCouponIds.length; i++) {
        const issuedCouponResponse = await apiWrapper("POST", "coupons", {
          master_coupon_id: gettableMasterCouponIds[i],
          user_ids: [user_id],
          book_ids: [bookId],
        });

        issuedExternalMasterCouponIds.push(gettableMasterCouponIds[i]);

        store.commit(
          "ticketing/setIssuedExternalMasterCouponIds",
          issuedExternalMasterCouponIds
        );
        issuedCount++;
      }
    } else {
      console.log("issueExternalCoupon :>> no coupons");
    }

    if (issuedCount < gettableMasterCouponIds.length) {
      throw new Error(
        `Fail to Issued External Coupons: ${issuedCount}/${gettableMasterCouponIds.length}`
      );
    }

    return issuedCount;
  } catch (err) {
    console.log('ERROR"" issueExternalCouponForValidBook', err);
    throw err;
  }
};
